import { Box, Typography } from '@mui/material';

interface PieStageDatum {
  name: string;
  value: number;
  percentage: string;
  color: string;
}

interface PieStageTooltipProps {
  active?: boolean;
  payload?: ReadonlyArray<{ payload: PieStageDatum }>;
}

/** Pie chart tooltip showing feet and percentage (UDOMI-925). */
export function PieStageTooltip({ active, payload }: PieStageTooltipProps) {
  if (!active || !payload?.length) {
    return null;
  }

  const item = payload[0].payload as PieStageDatum;

  return (
    <Box
      sx={{
        p: 1,
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
      }}
    >
      <Typography variant="body2" sx={{ color: item.color, fontWeight: 600 }}>
        {item.name}
      </Typography>
      <Typography variant="body2">
        {item.value.toFixed(2)} ft ({item.percentage}%)
      </Typography>
    </Box>
  );
}
